import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetupFamilyComponent} from './pages/setup-family.component';
import { SetupFamilyService} from './setup-family.service';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { FormsModule } from '@angular/forms';
import {HttpModule} from '@angular/http';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MaterialModule,
        FormsModule,
        HttpModule
    ],
    declarations: [SetupFamilyComponent],
    providers: [SetupFamilyService]
})
export class SetupFamilyModule { }
